<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="健康数据"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <table class="ui-box-table">
        <tr>
          <th style="width:20%">指标</th>
          <th style="width:20%">测量值</th>
          <th style="width:20%">测量时间</th>
          <th style="width:20%">结果</th>
          <th style="width:20%">历史</th>
        </tr>
        <tr>
          <td style="width:20%">胎心</td>
          <td style="width:20%">{{healthlVo.cardiacDevice&&healthlVo.cardiacDevice.tbCardiacRate+'bpm'||'-'}}</td>
          <td style="width:20%">{{healthlVo.cardiacDevice&&new Date(healthlVo.cardiacDevice.createTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%">{{healthlVo.cardiacDevice&&healthlVo.cardiacDevice.tbScore+'分'||'-'}}</td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('胎心历史','heart',`/patient/heart`,{tbId:data.tbUserId,week:data.currentGeneration ==1 ? data.tbWeek:'已出生'})">查看</td>
        </tr>
        <tr>
          <td style="width:20%">胎动</td>
          <td style="width:20%">{{healthlVo.tbBabyBeat&&healthlVo.tbBabyBeat.tbBeatNumber+'次/小时'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbBabyBeat&&new Date(healthlVo.tbBabyBeat.tbRecordTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbBabyBeat">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbBabyBeat.tbBeatNumber>2&&healthlVo.tbBabyBeat.tbBeatNumber<9">正常</td>
          <td style="width:20%" v-else>
            <div class="error">异常</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('胎动历史','move',`/patient/move`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">黄疸</td>
          <td style="width:20%">{{healthlVo.tbJaundiceDevice&&healthlVo.tbJaundiceDevice.tbJaundiceValue+'mg/dl'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbJaundiceDevice&&new Date(healthlVo.tbJaundiceDevice.createTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbJaundiceDevice">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbJaundiceDevice.tbState==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">异常</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('黄疸历史','jaundice',`/patient/jaundice`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">宫缩</td>
          <td style="width:20%">{{healthlVo.tbUserContraction&&healthlVo.tbUserContraction.tbDuration+'秒'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbUserContraction&&new Date(healthlVo.tbUserContraction.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%">-</td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('宫缩历史','contraction',`/patient/contraction`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">心率</td>
          <td style="width:20%">{{healthlVo.tbDeviceHeartRate&&healthlVo.tbDeviceHeartRate.tbValue+'bpm'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceHeartRate&&new Date(healthlVo.tbDeviceHeartRate.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbDeviceHeartRate">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbDeviceHeartRate.status==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">{{healthlVo.tbDeviceHeartRate.statusName}}</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('心率历史','heartRate',`/patient/heartRate`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">血糖</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodGlucose&&healthlVo.tbDeviceBloodGlucose.tbValue+'mmol/L'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodGlucose&&new Date(healthlVo.tbDeviceBloodGlucose.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbDeviceBloodGlucose">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbDeviceBloodGlucose.status==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">{{healthlVo.tbDeviceBloodGlucose.statusName}}</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('血糖历史','bloodGlucose',`/patient/bloodGlucose`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">血氧</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodOxygen&&healthlVo.tbDeviceBloodOxygen.tbValue+'%'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodOxygen&&new Date(healthlVo.tbDeviceBloodOxygen.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbDeviceBloodOxygen">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbDeviceBloodOxygen.status==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">{{healthlVo.tbDeviceBloodOxygen.statusName}}</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('血氧历史','bloodOxygen',`/patient/bloodOxygen`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">血压</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodPressure&&healthlVo.tbDeviceBloodPressure.tbValue+'mmHg'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodPressure&&new Date(healthlVo.tbDeviceBloodPressure.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbDeviceBloodPressure">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbDeviceBloodPressure.status==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">{{healthlVo.tbDeviceBloodPressure.statusName}}</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('血压历史','bloodPressure',`/patient/bloodPressure`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">血脂</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodFat&&healthlVo.tbDeviceBloodFat.tbValue+'mmol/L'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceBloodFat&&new Date(healthlVo.tbDeviceBloodFat.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbDeviceBloodFat">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbDeviceBloodFat.status==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">{{healthlVo.tbDeviceBloodFat.statusName}}</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('血脂历史','bloodFat',`/patient/bloodFat`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">尿酸</td>
          <td style="width:20%">{{healthlVo.tbDeviceUricAcid&&healthlVo.tbDeviceUricAcid.tbValue+'μmol/L'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceUricAcid&&new Date(healthlVo.tbDeviceUricAcid.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbDeviceUricAcid">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbDeviceUricAcid.status==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">{{healthlVo.tbDeviceUricAcid.statusName}}</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('尿酸历史','uricAcid',`/patient/uricAcid`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">睡眠</td>
          <td style="width:20%">{{healthlVo.tbDeviceSleep&&healthlVo.tbDeviceSleep.timeLength+'小时'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceSleep&&new Date(healthlVo.tbDeviceSleep.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%">-</td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('睡眠历史','sleep',`/patient/sleep`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">体温</td>
          <td style="width:20%">{{healthlVo.tbDeviceTemperature&&healthlVo.tbDeviceTemperature.tbValue+'°C'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceTemperature&&new Date(healthlVo.tbDeviceTemperature.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%" v-if="!healthlVo.tbDeviceTemperature">-</td>
          <td style="width:20%" v-else-if="healthlVo.tbDeviceTemperature.status==1">正常</td>
          <td style="width:20%" v-else>
            <div class="error">{{healthlVo.tbDeviceTemperature.statusName}}</div>
          </td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('体温历史','temperature',`/patient/temperature`,{tbId:data.tbUserId})">查看</td>
        </tr>

        <tr>
          <td style="width:20%">计步</td>
          <td style="width:20%">{{healthlVo.tbDeviceStep&&healthlVo.tbDeviceStep.tbValue+'步'||'-'}}</td>
          <td style="width:20%">{{healthlVo.tbDeviceStep&&new Date(healthlVo.tbDeviceStep.tbStartTime).format('yyyy-MM-dd hh:mm')||'-'}}</td>
          <td style="width:20%">-</td>
          <td style="width:20%;color:#1890FF;cursor: pointer;" @click="openTab('计步历史','step',`/patient/step`,{tbId:data.tbUserId})">查看</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import titleComponents from '@/components/mother/title'
export default {
  name: 'healthInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    healthlVo: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      show: true
    }
  },
  created () {

  },
  computed: {
    ...mapGetters([
      'lastBreadCrumb',
      'refreshPage'
    ])
  },
  methods: {

  },
  components: {
    titleComponents
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .baseInfo-content {
      display: flex;
      align-content: center;
      margin-bottom: 25px;
      .text {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 22px;
        margin-right: 60px;
      }
    }
    .ui-box-table {
      table-layout: fixed;
      text-align: center;
      width: 100%;
      border: 1px solid #d8d8d8;
      border-radius: 6px;
      border-collapse: collapse;
      border-style: hidden;
      box-shadow: 0 0 0 1px #e0e0e0;
      overflow: hidden;
      tr {
        border: 1px solid #e0e0e0;
        height: 54px;
        line-height: 54px;
        th {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 700;
          color: #000000;
          text-align: center;
          border: 1px solid #e0e0e0;
        }
        td {
          background: #ffffff;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          border: 1px solid #e0e0e0;
          .error {
            margin: 0 auto;
            width: 64px;
            height: 30px;
            border-radius: 16px;
            border: 1px solid #e02020;
            font-weight: 400;
            font-size: 16px;
            color: #e02020;
            line-height: 30px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
     